import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { getLinkFichaCatalograficaByMarca } from '../commons/menu/biblioteca-virtual/ficha-catalografica/ficha-catalografica.config';
import { getItensMenuConfig } from '../commons/menu/menu.config';
import { paraMsalConfiguration } from '../commons/msal.commons';
import { getTapumeConfig } from '../commons/tapume-erro-carregamento/tapume-erro-carregamento.config';
import { Environment } from '../types';

const buildSettings = (): UserManagerSettings => ({
  authority: 'https://login.microsoftonline.com/da49a844-e2e3-40af-86a6-c3819d704f49/v2.0/',
  client_id: 'c2cd8cdf-a27d-46e1-a8fd-4778406cba96',
  redirect_uri: `${window.location.protocol}//${window.location.host}`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}`,
  scope: 'c2cd8cdf-a27d-46e1-a8fd-4778406cba96/.default',
  monitorSession: false,
  userStore: new WebStorageStateStore({ store: localStorage }),
  prompt: 'select_account',
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: false,
});

const dev = (): Environment => {
  const settings: UserManagerSettings = buildSettings();
  const apiUrl = localStorage.getItem('apiUrl');
  const apiV2Url = localStorage.getItem('apiV2Url');
  const ambiente = 'dev';
  const marca = 'estacio';

  return {
    contextos: [
      {
        host: 'https://educador-frontend.estaciodev.net',
        redirect: 'https://educador-sava-estacio.estaciodev.net',
      },
      {
        host: 'https://educador-aura-estacio.estaciodev.net',
        redirect: 'https://educador-sava-estacio.estaciodev.net',
      },
      {
        host: 'https://educador-sava-estacio.estaciodev.net',
        redirect: 'https://educador.estacio.sava.dev.yduqs.com.br',
      },
      { host: 'https://educador.estacio.sava.dev.yduqs.com.br' },
    ],
    ambiente,
    marca,
    idClienteEnsineme: 'A39EAE23-8E99-27B8-82FC-D5ABAF8953CD',
    URL_REDIRECT_ENSINEME: 'https://stecine.azureedge.net/repositorio/redirect/_redirect.html',
    URL_REDIRECT_REDEFINIR_SENHA: 'https://account.activedirectory.windowsazure.com/ChangePassword.aspx',
    URL_ESQUECEU_SENHA: 'https://passwordreset.microsoftonline.com/',
    API: apiUrl ?? 'https://sava-estacio.estaciodev.net/apis',
    API_DEDICADA: apiUrl ?? 'https://apis.educador.estacio.sava.dev.yduqs.com.br/rest',
    API_V2: apiV2Url ?? 'https://hmlapi.estacio.br/desenv/aura-frontend',
    URL_ALUNO: 'https://estudante.estacio.sava.dev.yduqs.com.br/',
    URL_FAQ: '/aura-repo/faq-educador.pdf',
    URL_MANUAL: '/aura-repo/manual-educador.pdf',
    URL_BASE_CALENDARIO_ACADEMICO: '/aura-repo/calendario-academico/',
    EVENT_LOGIN_ENDPOINT: '/v2/eventos-login/educadores',
    userManagerSettings: settings,
    msalConfiguration: paraMsalConfiguration({ settings }),
    GTM_ID: 'GTM-56HT2PR',
    TAMANHO_PAGINA_RESPOSTA_TRABALHOS: 5,
    ITENS_MENU: getItensMenuConfig({ ambiente, marca }),
    URL_FICHA_CATALOGRAFICA: getLinkFichaCatalograficaByMarca(marca),
    TAPUME_CONFIG: getTapumeConfig({ marca }),
    URL_ADOBE_LAUNCH_SCRIPT:
      'https://assets.adobedtm.com/0b3049c26621/a6dfba573ee8/launch-a6935f17b378-development.min.js',
  };
};

export default dev;
